// Path: src\Components\WorldOfEports\EsportsNews.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import BaseHome from "../Home/BaseHome";
import LevelIcon from "../../assets/images/level.png";
import Newsimg from "../../assets/images/gamenews.jpeg";
import { getBlogs, getBlogDetails } from "../../api/worldOfEsports.api";
import { url } from "../../config/url";
import { useNavigate } from "react-router-dom";
import ListLoader from "../Common/ListLoader";
import { t } from "i18next";

const WorldOfEportsNews = () => {
  const navigate = useNavigate();
  const [blogList, setBlogList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(18);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currentPage <= totalPages) loadMore();
  }, [currentPage]);

  const loadMore = async () => {
    fetchBlogList();
  };

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchBlogList = async () => {
    setLoading(true);
    try {
      const data = {
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: "createdAt",
          sortDirection: "desc",
        },
      };
      const res = await getBlogs(data);
      setLoading(false);
      if (res?.success && res?.data) {
        setBlogList([...blogList, ...res?.data]);
        setTotalPages(res?.totalPages);
      } else {
        setBlogList([]);
      }
    } catch (error) {
      setLoading(false);
      setBlogList([]);
    }
  };

  // const handleArticleClick = () => {
  //     navigate(`WorldOfEports/EsportDetail`); // Redirect to the detail page
  //   };
  const handleArticleClick = (id) => {
    navigate(`/world-of-eports/detail/${id}`); // Navigate to the detail page with the blog ID
  };

  return (
    <BaseHome
      isFooter={false}
      title={t("woe.esports_news")}
      MaxFullPageScroll={true}
    >
      {blogList?.length > 0 ? (
        <div className="world-of-esports-main-wrap">
          <div className="row">
            {blogList?.length > 0 &&
              blogList.map((data, index) => (
                <div
                  className="col-4 ps-1 pe-1"
                  key={index}
                  ref={
                    blogList?.length === index + 1 ? lastPostElementRef : null
                  }
                >
                  {/* <div className='esports-news-cointner mt-4' onClick={() => handleArticleClick(data.id)}> */}
                  <div
                    className="esports-news-container mt-4"
                    onClick={() => handleArticleClick(data._id)}
                  >
                    <div className="esports-news-card">
                      <div className="esports-news-image">
                        <img src={url?.IMAGE_URL + data?.img}></img>
                      </div>
                      <div className="esports-news-content">
                        {data?.title?.length > 10 ? (
                          <marquee>{data?.title}</marquee>
                        ) : (
                          data?.title
                        )}
                        {/* <h3 className="esports-news-heading">{data?.title}</h3> */}
                        <p className="esports-news-body">
                          {data?.shortDescription}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      ) : (
        !loading && (
          <div className="w-100 d-flex justify-content-center">
            <span className="text-center">No data found</span>
          </div>
        )
      )}
      {loading && (
        <div className="w-100 d-flex justify-content-center">
          {" "}
          <ListLoader />
        </div>
      )}
    </BaseHome>
  );
};

export default WorldOfEportsNews;
